// extracted by mini-css-extract-plugin
export default {"external-rating-box":"index_external-rating-box__VPbkf"};